module.exports = __webpack_public_path__ + "static/1-pen-lighthouse-5ecc49b9101ec112fa9a85605af561ad.png";